import React, {useState} from 'react'
import Container from '@mui/material/Container'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import Wizard, {StepProps} from '../../components/forms/Wizard'
import {
  BasicSettings,
  EvaluationTasksUrl,
  CSVChecker,
  ConfigureColumns,
} from '../../components/evaluations/configure'
import {Evaluation as EvaluationType} from '../../services/types'

const TasksOverwriteInfo = () => (
  <Typography>
    This wizard helps you choose and configure a CSV file containing tasks for this evaluation. All
    tasks from the CSV file will be added, without checking for duplicates. This means that if your
    CSV file contains tasks that already exist for this evaluation, there will be multiple copies of
    that task. Which in turn means that it's a lot more likely for that task to be sent to models
    when they are being evaluated.
  </Typography>
)

type EvaluationWizardProps = {
  initial?: EvaluationType
  onSave: (e: EvaluationType) => Promise<string | null>
  basic?: boolean
  tasksOverwrite?: boolean
  tasksUrl?: boolean
  configureCSV?: boolean
  checkCSV?: boolean
}
const EvaluationWizard = ({
  initial,
  onSave,
  basic,
  tasksOverwrite,
  tasksUrl,
  configureCSV,
  checkCSV,
}: EvaluationWizardProps) => {
  const [evaluation, setEvaluation] = useState(initial || ({} as unknown as EvaluationType))

  const onChange = (field: string, val: any) => setEvaluation((e) => ({...e, [field]: val}))
  const onSubmit = async () => onSave(evaluation)

  const props = {evaluation, onChange}
  const steps = [
    basic && {
      label: 'Basic settings',
      Step: BasicSettings,
      extraProps: props,
    },
    tasksOverwrite && {
      label: 'Tasks upload information',
      Step: TasksOverwriteInfo,
    },
    tasksUrl && {
      label: 'Tasks CSV URL',
      Step: EvaluationTasksUrl,
      extraProps: props,
    },
    configureCSV && {
      label: 'Configure CSV columns',
      Step: ConfigureColumns,
      extraProps: props,
    },
    checkCSV && {
      label: 'Check CSV file',
      Step: CSVChecker,
      extraProps: props,
    },
  ].filter(Boolean) as StepProps<any>[]
  if (steps.length) {
    return <Wizard sx={{mt: 4}} onFinish={onSubmit} steps={steps} />
  }
  return null
}

const modalStyle = {
  mt: 10,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  overflowY: 'auto',
  maxHeight: 'calc(100% - 80px)', // Subtract some pixels for margin
}

type EvalWizardModalProps = {
  show?: boolean
  onCancel: () => void
} & EvaluationWizardProps
export const EvalWizardModal = (props: EvalWizardModalProps) => {
  return (
    <Modal open={props.show || false} onClose={props.onCancel}>
      <Container sx={{flex: 1, ...modalStyle}}>
        <EvaluationWizard {...props} />
      </Container>
    </Modal>
  )
}

export default EvaluationWizard
